import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import {
  useFavorite,
  useOpenEditor,
  useProgramAuthor,
  useProgramDelete,
  useProgramShare,
  useRecommendModal,
} from '@features/programs';
import { useUser } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import * as st from '@shared/styles/smallCardMenu.module.scss';
import { DropdownItem, useMenuDropdown } from '@shared/ui';
import { DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu/ui';

interface Props {
  id: number;
  authorId: number;
  isFavorite: boolean;
  isPaid: boolean;
  needDropDawnShowUp?: boolean;
  coachId?: number;
  onMenuItemClick?: () => void;
}

export const Menu: React.FC<Props> = ({
  id: programId,
  authorId,
  coachId,
  isFavorite,
  isPaid,
  needDropDawnShowUp,
  onMenuItemClick,
}) => {
  const { menuRef, onClose, handleToggleDropdown, isMenuOpen, handleAction } = useMenuDropdown({
    onMenuItemClick,
  });

  const { isAuthor } = useProgramAuthor(authorId);
  const { toggleRecommendModal } = useRecommendModal();

  const { favoriteBtn } = useFavorite({ programId, isFavorite, isPaid });
  const { edit } = useOpenEditor(programId);
  const { removeProgram } = useProgramDelete(programId);

  const { permissions, code } = useModuleByCodeParam();
  const { toggleShareModal } = useProgramShare();
  const { isAuth } = useUser();
  const navigate = useNavigate();

  return (
    <DropdownMenuWithButton
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
      dropDownClassName={cn(
        needDropDawnShowUp ? st.lastMenu : undefined,
        needDropDawnShowUp && !isAuthor ? st.lastMenuWhenIsNotAuthor : undefined
      )}
      mouseLeaveAreaClassName={needDropDawnShowUp ? st.lastMenuMouseLeaveArea : undefined}
    >
      {!isAuthor && isAuth && (
        <DropdownItem onClick={handleAction(favoriteBtn.onClick)}>{favoriteBtn.text}</DropdownItem>
      )}
      {isAuthor && <DropdownItem onClick={handleAction(edit)}>Изменить</DropdownItem>}
      {permissions.can_sell && (
        <DropdownItem onClick={handleAction(() => toggleRecommendModal(programId))}>
          Рекомендовать
        </DropdownItem>
      )}
      {((permissions.can_buy && !permissions.can_sell) || !isAuth) && (
        <DropdownItem onClick={handleAction(() => toggleShareModal(programId))}>
          Поделиться
        </DropdownItem>
      )}
      {!isAuthor && coachId && (
        <DropdownItem onClick={handleAction(() => navigate(`/coaches/specialists/${coachId}`))}>
          Об авторе
        </DropdownItem>
      )}
      {isAuthor && (
        <DropdownItem
          onClick={handleAction(() =>
            navigate(`/programs/${code}/program/${programId}/publication`)
          )}
        >
          Публикация
        </DropdownItem>
      )}
      {isAuthor && <DropdownItem onClick={handleAction(removeProgram)}>Удалить</DropdownItem>}
    </DropdownMenuWithButton>
  );
};
